import { Omit } from 'bold-ui'
import { SelectField, SelectFieldProps } from 'components/form/final-form'
import { TipoDestinoLixoEnum } from 'graphql/types.generated'
import React from 'react'

import { tipoDestinoLixoEnumRecord, tipoDestinoLixoValidoEnumList } from './condicoes-moradia-model'

export interface TipoDestinoLixoSelectFieldProps
  extends Omit<SelectFieldProps<TipoDestinoLixoEnum>, 'items' | 'itemToString'> {
  showItensLegados: Boolean
}

export function TipoDestinoLixoSelectField(props: TipoDestinoLixoSelectFieldProps) {
  const items = props.showItensLegados ? allItems : tipoDestinoLixoValidoEnumList
  return <SelectField<TipoDestinoLixoEnum> items={items} itemToString={itemToString} {...props} />
}

const allItems = Object.values(TipoDestinoLixoEnum)
const itemToString = (item: TipoDestinoLixoEnum) => item && tipoDestinoLixoEnumRecord[item]
